import React from "react";
import { Link } from "react-router-dom";
import ActivityFooter from "../common/ActivityFooter";

const BurndownChartIntro = ({ color, onBack, onContinue }) => {
  return (
    <div>
      <div className="content-area flex-grow">
        <div className="bg-gallery px-15 sm:px-50 lg:px-15 py-11">
          <div className="lg:max-w-520 mx-auto">
            <h1 className="uppercase font-bold text-gray-800 my-0 text-md">
              CREATE AN BURNDOWN CHART
            </h1>
          </div>
        </div>
        <div className="inner-content px-15 sm:px-50 lg:px-15 pt-19 mx-auto pb-25 lg:pb-8 text-gray-800">
          <p>
            By keeping the burndown chart current, project managers can offer
            their customers a quick, visual representation of the functionality
            that has been delivered and is left to be delivered, and provides
            clues regarding the team’s productivity.
          </p>
          <p>Let’s make one!</p>
          <p>
            But first, you need a project. Check out “WHAT’S MY PROJECT” to find
            out what you and your team are building. You can skip this if you
            already know about your project.
          </p>
          <div className="pt-65 text-center">
            <div>
              <img
                className="inline-block align-top"
                src="images/img68.jpg"
                alt=" description"
                width="69"
                height="51"
              />
            </div>
            <Link
              to="/app/story"
              className="font-secondary uppercase font-bold text-center border border-orange-100 text-orange-100 inline-block align-top px-19 pt-20 pb-17 text-center hover:text-white hover:bg-orange-100"
            >
              WHAT’S MY PROJECT?
            </Link>
          </div>
        </div>
      </div>

      <ActivityFooter color={color} onBack={onBack} onContinue={onContinue} />
    </div>
  );
};

export default BurndownChartIntro;
